import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { ApiService } from '@frontend/sports/common/api-utils';
import { NativeAppService, Page } from '@frontend/vanilla/core';
import { Observable, map } from 'rxjs';

export interface PrettyUrlApiResponse {
    [language: string]: string;
}

@Injectable({ providedIn: 'root' })
export class NoMatchRouteGuard {
    private router = inject(Router);
    private nativeAppService = inject(NativeAppService);
    private apiService = inject(ApiService);
    private page = inject(Page);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree | boolean> | boolean {
        if (!this.nativeAppService.isNative) {
            return true;
        }
        const urlParams = {
            url: state.url,
            sourceLanguage: 'en',
            targetLanguages: this.page.lang,
        };

        return this.apiService.get<PrettyUrlApiResponse>('url', urlParams).pipe(
            map((result) => {
                if (result[this.page.lang] !== decodeURI(state.url)) {
                    return this.router.parseUrl(result[this.page.lang]);
                }

                return true;
            }),
        );
    }
}
